import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Hidden, Chip } from '@material-ui/core';
import clsx from 'clsx';
import uniqBy from 'lodash/uniqBy';

import { setFilterState, selectSpace } from 'features/filterInventorySlice';
import NetworkIcon from 'components/NetworkIcon';
import Badge from 'components/Badge';
import styles from 'styles/components/profile/FilterInventory.module.scss';

const FilterInventory = ({ networks, inventories, uniqInfluencerNetworks }) => {
  const [hovered, setHovered] = useState(null);
  const selectedNetworkIds = useSelector(state => state.filterInventory.selectedNetworkIds);
  const selectedSpaces = useSelector(state => state.filterInventory.selectedSpaces);
  const dispatch = useDispatch();

  const selectedFilters = selectedNetworkIds.length + selectedSpaces.length;

  const allSpaces = uniqBy(
    inventories.map(inventory => inventory.inventory_space),
    'name'
  );

  const inventorySpaces = allSpaces.filter(space =>
    selectedNetworkIds.every(networkId =>
      networks[networkId]?.availableSpaces?.includes(space.name)
    )
  );

  const selectNetwork = id => {
    const networkIds = selectedNetworkIds.includes(id)
      ? selectedNetworkIds.filter(i => i !== id)
      : [...selectedNetworkIds, id];

    const availableSpaces = allSpaces
      .filter(space =>
        networkIds.every(networkId => networks[networkId]?.availableSpaces?.includes(space.name))
      )
      .map(space => space.name);

    const spaces =
      selectedNetworkIds.length === 0
        ? []
        : selectedSpaces.filter(space => availableSpaces?.includes(space));

    dispatch(setFilterState({ spaces, networkIds }));
  };

  return (
    <div className={styles.filter}>
      {uniqInfluencerNetworks.length > 1 && (
        <div className={styles.header}>
          <h4>Filter</h4>

          {selectedFilters > 0 && (
            <Badge
              content={selectedFilters}
              badgeStyles={{
                right: 15,
                fontSize: 16,
                minWidth: 33,
                height: 23,
                borderRadius: 11,
                backgroundColor: '#323643',
              }}
            />
          )}
        </div>
      )}

      <div className={styles.filterNetworks}>
        {uniqInfluencerNetworks.map(network => (
          <div
            className={styles.network}
            key={network.network.id}
            onClick={() => selectNetwork(network.network.id)}
            onMouseEnter={() => setHovered(network.network.id)}
            onMouseLeave={() => setHovered(null)}
          >
            <Hidden smDown>
              <NetworkIcon
                active={selectedNetworkIds.includes(network.network.id)}
                hovered={hovered === network.network.id}
                network={network.network}
                hasName={false}
                styles={styles}
              />
            </Hidden>

            <Hidden mdUp>
              <NetworkIcon
                active={selectedNetworkIds.includes(network.network.id)}
                network={network.network}
                styles={styles}
                hasName={false}
                width={40}
                height={40}
              />
            </Hidden>
          </div>
        ))}
      </div>

      {selectedNetworkIds.length > 0 && inventorySpaces.length > 0 && (
        <div className={`${styles.inventorySpaces} inventory-space-field`}>
          {inventorySpaces.map(space => (
            <Chip
              key={space.id}
              label={space.name}
              color="secondary"
              variant={selectedSpaces.includes(space.name) ? 'default' : 'outlined'}
              className={clsx(styles.space)}
              onClick={() => dispatch(selectSpace(space.name))}
              clickable
            />
          ))}
        </div>
      )}
    </div>
  );
};

FilterInventory.propTypes = {
  networks: PropTypes.object.isRequired,
  inventories: PropTypes.array.isRequired,
  uniqInfluencerNetworks: PropTypes.array.isRequired,
};

export default FilterInventory;
